module.exports = __webpack_public_path__ + "assets/f49f84e5f1d46a8e3dbf48f8916068bd.png";